import type { ComponentType } from "react";
import type { PricingPageComponentProps } from "../pricing-page.interface";

export type LazyPageLoader = () => Promise<{ default: ComponentType<PricingPageComponentProps> }>;

export const PRODUCT_PRICING_PAGE_MAP: Record<string, LazyPageLoader> = {
  "example-product": () =>
    import("../../../../lib/pricing-pages/example-product-pricing-page/example-product-pricing-page"),
  generic: () => import("../../../../lib/pricing-pages/monthly-removal-pricing-page/MonthlyRemovalPricingPage"),
};
